export enum BtmReturnRequestStatus {
    New = "New",
    Pending = "Pending",
    Processed = "Processed",
    Accepted = "Accepted",
    PartiallyAccepted = "PartiallyAccepted",
    AutomaticallyAccepted = "AutomaticallyAccepted",
    Rejected = "Rejected",
}

export const BuildBtmReturnRequestStatusFromString = (status: string) => {
    switch (status) {
        case "New":
            return BtmReturnRequestStatus.New;
        case "Pending":
            return BtmReturnRequestStatus.Pending;
        case "Processed":
            return BtmReturnRequestStatus.Processed;
        case "Accepted":
            return BtmReturnRequestStatus.Accepted;
        case "PartiallyAccepted":
            return BtmReturnRequestStatus.PartiallyAccepted;
        case "AutomaticallyAccepted":
            return BtmReturnRequestStatus.AutomaticallyAccepted;
        case "Rejected":
            return BtmReturnRequestStatus.Rejected;
        default:
            throw Error(`Unknown status: ${status}`);
    }
};
